import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.some";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var tabDefalut = [{
  label: '商品条形码',
  prop: 'goodsBarcode',
  edit: true,
  type: 'd2Input'
}, {
  label: '出售价',
  prop: 'goodsPrice',
  edit: true,
  type: 'd2Input'
}, {
  label: '库存',
  prop: 'goodsStock',
  edit: true,
  type: 'd2Input'
}, {
  label: '重量(可不填)',
  prop: 'goodsWeight',
  edit: true,
  type: 'd2Input'
}, {
  label: '商家SKU(可不填)',
  prop: 'goodsSku',
  edit: true,
  type: 'd2Input'
}];
import { cloneDeep } from 'lodash';
import editTable from './editTable.vue';
export default {
  components: {
    editTable: editTable
  },
  data: function data() {
    return {
      attrList: [],
      tabDefalut: tabDefalut,
      tableProp: cloneDeep(tabDefalut),
      formData: {
        sellAttributes: [],
        goodsItems: []
      }
    };
  },
  mounted: function mounted() {
    this.getSellAttributes();
  },
  methods: {
    tabDelete: function tabDelete() {},
    //获取属性列表
    getSellAttributes: function getSellAttributes() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query, _yield$_this$$api$sel, records;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.attrList = [];
                query = _this.$route.query;
                _context2.next = 4;
                return _this.$api.sellAttributes({
                  goodsTypeId: query.goodsTypeId ? query.goodsTypeId : query.goodsTypeIdSecond ? query.goodsTypeIdSecond : query.goodsTypeIdFirst
                });

              case 4:
                _yield$_this$$api$sel = _context2.sent;
                records = _yield$_this$$api$sel.records;

                try {
                  cloneDeep(records).forEach( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(v) {
                      var params, data;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              params = {
                                sellAttributeId: v.sellAttributeId,
                                pageSize: 1000 * 1000
                              };
                              _context.next = 3;
                              return _this.$api.sellAttributeDetails(params);

                            case 3:
                              data = _context.sent;

                              _this.attrList.push(data);

                            case 5:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                } catch (_unused) {
                  _this.attrList = cloneDeep(records);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    changeCheckbox: function changeCheckbox(e, k) {
      var _this2 = this;

      this.tableProp = cloneDeep(tabDefalut);
      var tableList = [];
      this.attrList.forEach(function (v) {
        if (v.items.some(function (s) {
          return s.selected;
        })) {
          tableList.push(_objectSpread(_objectSpread({}, v), {}, {
            items: v.items.filter(function (f) {
              return f.selected;
            })
          }));
        }
      });
      var tabObj = {};
      tableList.forEach(function (v) {
        tabObj[v.attributeName] = v.items.map(function (m) {
          return m.itemValue;
        });
        var tab = {
          label: v.attributeName,
          prop: v.attributeName,
          width: '100px'
        };

        _this2.tableProp.unshift(tab);
      }); //暂存数据

      var list = []; // 循环每一个商品属性

      var result = this.combination(tabObj);
      result.forEach(function (v) {
        var obj = _objectSpread(_objectSpread({}, v), {}, {
          goodsItemId: '',
          itemSellAttributes: [],
          goodsBarcode: '',
          goodsPrice: '',
          goodsStock: '',
          goodsWeight: '',
          goodsSku: ''
        });

        if (_this2.formData.goodsItems.length == 0) {
          _this2.formData.goodsItems.push(obj);
        }

        _this2.formData.goodsItems.forEach(function (f) {
          var item = JSON.stringify(f);
          var key = JSON.stringify(v);
          key = key.replace('{', '');
          key = key.replace('}', '');

          if (item.includes(key)) {
            console.log(123);
          } else {
            _this2.formData.goodsItems.push(obj);
          }
        });
      }); //   this.formData.goodsItems = cloneDeep(list)

      console.log(this.formData.goodsItems, list);
      return;
      this.attrList.forEach(function (v) {
        _this2.formData.goodsItems.forEach(function (f) {
          Object.keys(f).forEach(function (k) {
            if (v.attributeName == k) {
              var item = v.items.find(function (s) {
                return s.itemValue == f[k];
              });
              f.itemSellAttributes.push(item);
            }
          });
        });
      });
      this.formData.sellAttributes = tableList;
      this.$forceUpdate();
    },
    //排列组合
    combination: function combination(tabObj) {
      return Object.keys(tabObj).reduce(function (result, key) {
        // 循环属性的每一个值
        return tabObj[key].reduce(function (acc, value) {
          // 对于第一个属性
          if (!result.length) {
            // 将数值转化为对象格式
            return acc.concat(_defineProperty({}, key, value));
          } // 对于第一个之后的属性，将新的属性和值添加到已有结果，并进行拼接。


          return acc.concat(result.map(function (ele) {
            return Object.assign({}, ele, _defineProperty({}, key, value));
          }));
        }, []);
      }, []);
    }
  }
};